export function getConfig() {
  // Production runtime (via env-config.js)
  if (window.__MAOS_CONFIG__) {
    return window.__MAOS_CONFIG__;
  }

  // Local dev (react-dotenv)
  if (window.env) {
    return {
      API_URL: window.env.MAOS_API_URL,
      WS_URL: window.env.MAOS_WS_URL,

      DISCORD_CLIENT_ID: window.env.MAOS_DISCORD_CLIENT_ID,
      DISCORD_REDIRECT_URI: window.env.MAOS_DISCORD_REDIRECT_URI,

      SPOTIFY_CLIENT_ID: window.env.MAOS_SPOTIFY_CLIENT_ID,
      SPOTIFY_REDIRECT_URI: window.env.MAOS_SPOTIFY_REDIRECT_URI
    };
  }

  throw new Error("No environment config found.");
}